// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"9fe9b391","156":"50f7e504","344":"1effedc7","438":"387cc76a","706":"150f567c","726":"570f20ee"}[chunkId] + ".chunk.js";
};